import { cn } from "@tine/designsystem-utils";

type FullWidthBackgroundProps = {
   color: string;
};

/**
 * FullWidthBackground Component
 *
 * This component creates a full-width background that spans the entire viewport
 * width, regardless of the parent container's width. It is designed to be used
 * in a layout where a background color or image is desired to extend beyond the
 * confines of the container.
 *
 * @param {string} color - The Tailwind CSS class for the background color.
 *
 * @returns {JSX.Element} The rendered FullWidthBackground component.
 *
 * @example
 * // Usage in a parent component
 * import FullWidthBackground from '../FullWidthBackground';
 *
 * <div className="relative">
 *    {someCondition && <FullWidthBackground color="bg-some-color" />}
 * </div>
 *
 * @note
 * Ensure that the parent container has `relative` positioning to correctly
 * align the absolute positioning of this component.
 *
 * w-[calc(100vw-15px)] is used to account for the scrollbar width in the viewport.
 */

const FullWidthBackground = ({ color }: FullWidthBackgroundProps): JSX.Element => {
   return <div className={cn(color, "absolute left-1/2 -z-10 h-full w-[calc(100vw-15px)] -translate-x-1/2 transform")} />;
};

export default FullWidthBackground;
